export const TINYSLICE_PREFIX = '[TinySlice]';
export const TINYSLICE_INTERNAL_PREFIX = `${TINYSLICE_PREFIX} [Internal]`;
export const TINYSLICE_DEFAULT_PREFIX = `${TINYSLICE_PREFIX} [Default]`;
